import { initAlpineScripts } from "./_alpine/index";
import { updateUrlWithVariantId } from "./_utils/product";

const { HYDRATE_VARIANT_ID } = window;

const urlSearchParams = new URLSearchParams(window.location.search);
const query = Object.fromEntries(urlSearchParams.entries());
const variantId = Number(query.variant) || HYDRATE_VARIANT_ID;

initAlpineScripts();

if (variantId) {
  updateUrlWithVariantId(variantId);
}
